import React from "react";

function Support() {
  return (
    <div className="support container">
      <h1>Support</h1>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions or need assistance with Geekun, feel free to
          reach out to us at:
        </p>
        <p>
          Email: <span className="email-link">geekun.business@gmail.com</span>
        </p>
        <p>We’ll do our best to respond to your inquiry as soon as possible.</p>
      </section>

      <section>
        <h2>Frequently Asked Questions (FAQ)</h2>

        <h3>1. How does Geekun work?</h3>
        <p>
          Geekun allows you to identify anime and manga from images. Simply
          upload an image, and the app will recognize the series and provide
          detailed information about it.
        </p>

        <h3>2. Is the app free to use?</h3>
        <p>
          Yes, Geekun is free to use. However, we display ads within the app to
          support its development.
        </p>

        <h3>3. Why can't Geekun find the anime or manga in my image?</h3>
        <p>
          There are several reasons why Geekun might not recognize an image:
        </p>
        <ul>
          <li>
            <strong>
              The image is not an original anime/manga screenshot:
            </strong>{" "}
            Geekun works best with unmodified frames from anime episodes or
            manga panels.
          </li>
          <li>
            <strong>The anime or manga is not yet in our database:</strong> We
            constantly update our database, but some newer or lesser-known
            titles may not be recognized yet.
          </li>
          <li>
            <strong>The image has been edited or modified:</strong> Heavy
            cropping, adding filters (grayscale, high contrast, brightness
            adjustments), or altering colors can make recognition less accurate.
          </li>
          <li>
            <strong>The image is flipped, mirrored, or rotated:</strong>{" "}
            Significant transformations can make it harder to match with our
            database.
          </li>
          <li>
            <strong>Text covers too much of the image:</strong> Large subtitles,
            captions, or watermarks may interfere with the recognition process.
          </li>
          <li>
            <strong>The image lacks distinguishable features:</strong> Very dark
            images or those with large plain color blocks may not contain enough
            detail for accurate identification.
          </li>
          <li>
            <strong>Real-life photos of anime won't work:</strong> The system is
            designed for digital anime/manga images, not real-world objects like
            posters or figurines.
          </li>
        </ul>
        <p>
          If your image isn't recognized, try using a clearer, unedited version,
          or checking back later as we continue updating our database.
        </p>

        <h3>4. Why am I seeing ads in the app?</h3>
        <p>
          We display ads to keep the app free for users. Ads help support the
          ongoing development and maintenance of the app.
        </p>

        <h3>5. Does Geekun store my uploaded images?</h3>
        <p>
          No, Geekun does not store your uploaded images on our servers.
          However, images are stored on your device to keep track of your
          history and can be deleted from the cache in the Settings section of
          the app.
        </p>

        <h3>6. How do I report an issue or suggest a feature?</h3>
        <p>
          If you encounter a bug or have suggestions, contact us at{" "}
          <span className="email-link">geekun.business@gmail.com</span>. We
          appreciate your feedback!
        </p>
      </section>
    </div>
  );
}

export default Support;
